angular.module('unica_media.media_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// MEDIA
		.state('app.media', {
			url: '/media',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/media/templates/media.html',
					controller: 'MediaBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// MEDIA LIST
			.state('app.media.list', {
				url: '/list/:event_id/:directory_id',
				views: {
					'mediaContent': {
						templateUrl: './modules/media/templates/list.html',
						controller: 'MediaListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Lista Media',
					parent: function($scope) {
						return 'app.media_directory.list({ event_id:' + $scope.event_id + '})';
					}
				}
			});


});

